import { motion } from 'framer-motion';
import { useSlideUpVariants } from '../../hooks/useSlideUpVariants';
import './style.less';

export const AnimatedSection = ({ children, className, delay = 0 }) => {
  const variants = useSlideUpVariants(delay);

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1, margin: '0px 0px -50px 0px' }}
      variants={variants}
      className={`animated-section ${className || ''}`}
    >
      {children}
    </motion.div>
  );
};
